import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mail\">\n<path d=\"M15.667 13.6667H2.33366C1.41318 13.6667 0.666992 12.9205 0.666992 12V1.92752C0.705832 1.03547 1.44077 0.332507 2.33366 0.333352H15.667C16.5875 0.333352 17.3337 1.07954 17.3337 2.00002V12C17.3337 12.9205 16.5875 13.6667 15.667 13.6667ZM3.00033 2.00002L9.00033 6.00002L15.0003 2.00002H3.00033Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/mail.svg
// module id = ajop
// module chunks = 258